module.exports = __webpack_public_path__ + "static/img/xinyong-icon3.0b9e109f.png";